import { render, staticRenderFns } from "./ContactListImporter.vue?vue&type=template&id=52de206c&scoped=true&"
import script from "./ContactListImporter.vue?vue&type=script&lang=js&"
export * from "./ContactListImporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52de206c",
  null
  
)

export default component.exports